import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function PieChartLegend({ label, color }) {
    return (
        <div className="legend">
            <div style={{ backgroundColor: color }} className="rectangle"></div>
            <span className="legend-title">{label}</span>
        </div>
    );
}

PieChartLegend.propTypes = {
    label: PropTypes.string,
    color: PropTypes.string,
};

PieChartLegend.defaultProps = {
    label: '',
    color: '',
};

export default PieChartLegend;
